import React from 'react';

// Decorative animated sky layer (clouds, stars, balloons, bubbles).
// Purely cosmetic; sits behind page content. Shared across the child pages.
const SkyDecor = () => (
  <div className="sb-decor" aria-hidden="true">
    <span className="sb-cloud sb-cloud-1">☁️</span>
    <span className="sb-cloud sb-cloud-2">☁️</span>
    <span className="sb-cloud sb-cloud-3">☁️</span>
    <span className="sb-balloon sb-balloon-1">🎈</span>
    <span className="sb-balloon sb-balloon-2">🎈</span>
    <span className="sb-star sb-star-1">⭐</span>
    <span className="sb-star sb-star-2">✨</span>
    <span className="sb-star sb-star-3">🌟</span>
    <span className="sb-bubble sb-bubble-1" />
    <span className="sb-bubble sb-bubble-2" />
    <span className="sb-bubble sb-bubble-3" />
  </div>
);

export default SkyDecor;
